import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import Newsletter from "@/components/Newsletter";

const COLLECTIONS = [
  { n: "01", name: "Classic Dejon Richh", desc: "The foundation. Signature DR mark, cross artwork, vintage wash. The outfit starts here.", status: "AVAILABLE NOW", img: "/products/back.png", to: "/product/classic-dejon-richh-tee", live: true },
  { n: "02", name: "DR1 Graffiti Collection", desc: "Raw sketches turned wearable. Street-born artwork on premium blanks.", status: "COMING SOON", img: "/products/detail.png", live: false },
  { n: "03", name: "Hero Collection", desc: "Statement pieces built around one idea: the outfit is the hero.", status: "COMING SOON", img: "/products/hero-front.png", live: false },
  { n: "04", name: "Crochet Collection", desc: "Handcrafted texture meets streetwear silhouette. Slow-made, limited.", status: "COMING SOON", img: "/products/collar.png", live: false },
  { n: "05", name: "Future Drops", desc: "What's next stays in the dark until it's ready. Join the list for first access.", status: "IN THE WORKS", img: "/products/front.png", live: false },
];

export default function Collections() {
  return (
    <div data-testid="collections-page">
      <PageHeader overline="THE ARCHIVE & THE FUTURE" title="Collections" sub="Capsule releases built around complete outfits — not individual pieces." />

      <div className="mx-auto max-w-[1600px] px-5 sm:px-8 py-14">
        <div className="border-t border-wire">
          {COLLECTIONS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05}>
              {c.live ? (
                <Link to={c.to} data-testid={`collection-row-${c.n}`}
                  className="group grid grid-cols-12 items-center gap-4 border-b border-wire py-8 transition-colors hover:bg-charcoal/50 sm:gap-8">
                  <span className="col-span-2 sm:col-span-1 font-mono text-xs tracking-[0.3em] text-neutral-600">{c.n}</span>
                  <div className="col-span-10 sm:col-span-5">
                    <p className="font-display text-xl sm:text-2xl font-extrabold uppercase tracking-tight text-white">{c.name}</p>
                    <p className="mt-2 hidden max-w-md font-mono text-[11px] leading-relaxed tracking-wider text-neutral-500 sm:block">{c.desc}</p>
                  </div>
                  <span className="col-span-6 sm:col-span-3 font-mono text-[10px] tracking-[0.35em] text-neutral-300">{c.status}</span>
                  <div className="col-span-5 hidden sm:block sm:col-span-2">
                    <img src={c.img} alt={c.name} className="aspect-square w-full border border-wire object-cover" />
                  </div>
                  <span className="col-span-6 sm:col-span-1 flex justify-end text-neutral-500 transition-all group-hover:text-white">
                    <ArrowUpRight size={20} strokeWidth={1.5} />
                  </span>
                </Link>
              ) : (
                <div data-testid={`collection-row-${c.n}`} className="grid grid-cols-12 items-center gap-4 border-b border-wire py-8 opacity-60 sm:gap-8">
                  <span className="col-span-2 sm:col-span-1 font-mono text-xs tracking-[0.3em] text-neutral-600">{c.n}</span>
                  <div className="col-span-10 sm:col-span-5">
                    <p className="font-display text-xl sm:text-2xl font-extrabold uppercase tracking-tight text-neutral-400">{c.name}</p>
                    <p className="mt-2 hidden max-w-md font-mono text-[11px] leading-relaxed tracking-wider text-neutral-600 sm:block">{c.desc}</p>
                  </div>
                  <span className="col-span-6 sm:col-span-3 font-mono text-[10px] tracking-[0.35em] text-neutral-500">{c.status}</span>
                  <div className="col-span-5 hidden sm:block sm:col-span-2">
                    <img src={c.img} alt={c.name} className="aspect-square w-full border border-wire object-cover grayscale" />
                  </div>
                  <span className="col-span-6 sm:col-span-1" />
                </div>
              )}
            </Reveal>
          ))}
        </div>
      </div>
      <Newsletter />
    </div>
  );
}
